import { $applyNodeReplacement } from "lexical";
import type { LexicalNode } from "lexical";
import { SurveyAnswersNode } from "./survey-answers-node";
import { SurveyAnswersNodeMui } from "./survey-answers-node-mui";

export function $createSurveyAnswersNode(headless: boolean, surveyId = ""): SurveyAnswersNode {
  return $applyNodeReplacement(
    headless ? new SurveyAnswersNode(surveyId) : new SurveyAnswersNodeMui(surveyId),
  );
}

export function $isSurveyAnswersNode(
  node: LexicalNode | null | undefined,
): node is SurveyAnswersNode {
  return node instanceof SurveyAnswersNode;
}
